import React, { Fragment } from 'react';
import { map } from 'lodash';
import {
  abilityField,
  abilityNField,
  imageViewVerticalField
} from './fields';

const OpenEndHiddenFields = ({ question, relation = 'custom_metrics' }) => (
  <>
    <input
      type="hidden"
      name={ `project[${relation}][][${abilityField}]` }
      value={ question[abilityField] || false }
    />
    <input
      type="hidden"
      name={ `project[${relation}][][${abilityNField}]` }
      value={ typeof question[abilityNField] === 'undefined' || question[abilityNField] == null ? 1 : question[abilityNField] }
    />
    {
      map([ 'id', 'title', 'name', 'text', 'parent_id', 'kind', 'project_id' ], (reasonField) => (
        <Fragment key={ `${question.id}_${reasonField}` }>
          {
            !!question.reasons?.length &&
              <input
                type="hidden"
                name={ `project[${relation}][][reasons][][${reasonField}]` }
                value={ question.reasons[0][reasonField] || '' }
              />
          }
        </Fragment>
      ))
    }
    <input
      type="hidden"
      name={ `project[${relation}][][${imageViewVerticalField}]` }
      value={ question[imageViewVerticalField] || false }
    />
  </>
);

export default OpenEndHiddenFields;
